// Opened from a one-time link an admin created. Sets a new password, then sends the person to sign in.
import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { PASSWORD_MIN } from '@dpw/shared';
import { api } from '../api';
import { IconMoon, IconSun } from '../ui/icons';

export function SetPassword({ theme, onTheme }: { theme: 'light' | 'dark'; onTheme: () => void }) {
  const [sp] = useSearchParams();
  const token = sp.get('token') ?? '';
  const [pw, setPw] = useState('');
  const [again, setAgain] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (pw !== again) { setErr('The two passwords are not the same.'); return; }
    setBusy(true); setErr('');
    try { await api.auth.setPassword(token, pw); setDone(true); } catch (x) { setErr(x instanceof Error ? x.message : 'Could not set the password.'); } finally { setBusy(false); }
  };
  return (
    <div className="loginwrap">
      <form className="loginc" onSubmit={submit}>
        <div className="clogo"><i />Delta Partners</div>
        <div><h1 style={{ margin: '6px 0 4px', fontSize: 24, letterSpacing: '-.5px' }}>Set your password</h1><div className="sm mut">This link works once. Every device signed in to your account will be signed out.</div></div>
        {done ? (
          <>
            <div className="okmsg" role="status">Your password is set.</div>
            <Link className="bt pri" style={{ height: 44 }} to="/login">Sign in</Link>
          </>
        ) : !token ? <div className="err" role="alert">This link is not complete. Ask an admin for a new one.</div> : (
          <>
            <label className="fld">New password ({PASSWORD_MIN}+ characters)<input className="inp" type="password" autoComplete="new-password" minLength={PASSWORD_MIN} value={pw} onChange={e => setPw(e.target.value)} required autoFocus /></label>
            <label className="fld">Type it again<input className="inp" type="password" autoComplete="new-password" minLength={PASSWORD_MIN} value={again} onChange={e => setAgain(e.target.value)} required /></label>
            {err && <div className="err" role="alert">{err}</div>}
            <button className="bt pri" style={{ height: 44 }} disabled={busy}>{busy ? <span className="spin" /> : null}Set password</button>
          </>
        )}
      </form>
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <button className="ib" onClick={onTheme} aria-label="Switch light or dark">{theme === 'dark' ? <IconSun /> : <IconMoon />}</button>
      </div>
    </div>
  );
}
